export default {
  files: state => state.files
}
